import { render, staticRenderFns } from "./SetKeywordList.vue?vue&type=template&id=5ad4e552"
import script from "./SetKeywordList.vue?vue&type=script&lang=js"
export * from "./SetKeywordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports